/**
 * This file is specifically for DMA calculator tracking.
 */
import { isNullOrUndefined } from 'util';
import Accounting from 'accounting';
import TrackDataHelper from '../helpers/track-data-helper';
import AnalyticsHelper from '../helpers/analytics';
import SessionIdHelper from '../helpers/uuid-service';

let CalculatorUsedFlag = 0;
let CalculatorUsed = 'Debt Management Advisor:Credit Services Calculator';
const setCalcTrackData = () => {
    let CalcDataItemId = '';
    const elmBody = document.getElementsByTagName('body');
    if (typeof elmBody == 'object' && elmBody.length > 0) {
        CalcDataItemId = elmBody[0].getAttribute('data-item-id');
    }
    if (CalcDataItemId && !CalculatorUsedFlag) {
        CalculatorUsed += `:${CalcDataItemId}`;
        CalculatorUsedFlag = 1;
    }
};

const currencyFilter = figure => Accounting.formatNumber(figure, { precision: 2 });

const formatCurrency = (value) => {
    if (!isNullOrUndefined(value)) return `$${currencyFilter(value)}`;
    return 'N/A';
};
const outstandingDebtPayment = () => ({
    CC: `$${document.getElementById('CreditCardDebt').value}`,
    PL: `$${document.getElementById('PersonalLoanDebt').value}`,
    ME: `$${document.getElementById('MedicalDebt').value}`,
    OD: `$${document.getElementById('OtherDebt').value}`,
});
const trackWidgetCalculatorUsed = request => [
    { key: 'calculator_used', value: CalculatorUsed },
    { key: 'icid', value: 22460 },
    { key: 'preprime_loan_amount', value: `$${request.totalDebtAmount}` },
    {
        key: 'preprime_debt_amount',
        value: {
            CC: `$${request.creditCardDebtAmount}`, PL: `$${request.personalLoanDebtAmount}`, ME: `$${request.medicalDebtAmount}`, OD: `$${request.otherDebtAmount}`,
        },
    },
    { key: 'preprime_page_url', value: window.location.href },
    { key: 'preprime_credit_rating', value: request.creditBand },
    { key: 'preprime_rent_own', value: request.rentOrOwn },
    { key: 'preprime_advance_options', value: `DS:${request.debtSettlementSavings}%,${request.debtSettlementFees}%,CC:$${request.creditCardMinimumPayment},${request.creditCardAPR}%,PL:$${request.personalLoanMonthlyPayment},${request.personalLoanAPR}%,${request.personalLoanRemainingTermInMonths},HE:${request.homeEquityApr}%,${request.homeEquityTermInMonths}` },
    { key: 'preprime_state', value: request.stateCode },
];
const trackSavingBreakdownClicked = (savingData, text) => {
    const trackData = [
        { key: 'calculator_used', value: CalculatorUsed },
        { key: 'icid', value: 22460 },
        { key: 'preprime_loan_amount', value: formatCurrency(savingData.debtAmount) },
        { key: 'preprime_debt_section_clicked', value: savingData.savingName },
        { key: 'preprime_debt_amount', value: outstandingDebtPayment() },
        { key: 'preprime_debt_covered', value: formatCurrency(savingData.debtAmount) },
        { key: 'preprime_debt_notcovered', value: formatCurrency(savingData.debtNotCovered) },
        { key: 'preprime_offer_newInterestRate:', value: formatCurrency(savingData.interest) },
        { key: 'preprime_offer_newmonthlypayment', value: formatCurrency(savingData.monthlyPayment) },
        { key: 'preprime_offer_debtfreeby', value: isNullOrUndefined(savingData.debtFreeBy) ? 'N/A' : savingData.debtFreeBy },
        { key: 'preprime_offer_savings', value: formatCurrency(savingData.totalSavings) },
        { key: 'preprime_page_url', value: window.location.href },
    ];
    if (text) {
        trackData.push(
            { key: 'preprime_sid', value: SessionIdHelper.getSession() },
            { key: 'CTA_Clicked_URL', value: savingData.targetURL },
        );
    }
    return trackData;
};
const trackWidgetUsed = (request) => {
    setCalcTrackData();
    TrackDataHelper.setMany(trackWidgetCalculatorUsed(request), 'WidgetUsed');
    AnalyticsHelper.track('Widget Calculator Used', TrackDataHelper.get('WidgetUsed'));
};
const trackSavingOffersRedirect = (savingData, text) => {
    setCalcTrackData();
    TrackDataHelper.setMany(trackSavingBreakdownClicked(savingData, text), 'WidgetSavingClicked');
    AnalyticsHelper.track('Widget Calculator Clicked', TrackDataHelper.get('WidgetSavingClicked'));
};
const trackSavingDetailClick = (savingData) => {
    TrackDataHelper.setMany(trackSavingBreakdownClicked(savingData), 'SavinglDetailClicked');
    AnalyticsHelper.track('Widget Calculator Details Clicked', TrackDataHelper.get('SavinglDetailClicked'));
};

export {
    trackWidgetUsed,
    trackSavingOffersRedirect,
    trackSavingDetailClick,
};
